import { applySeo } from "@/lib/seo-head";
import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/site/Layout";
import { ConfirmationLayout } from "@/components/checkout/ConfirmationLayout";
import { useT } from "@/lib/i18n";

export const Route = createFileRoute("/reserva-confirmada")({
  component: BookingConfirmed,
  validateSearch: (s: Record<string, unknown>) => ({
    session_id: typeof s.session_id === "string" ? s.session_id : undefined,
  }),
  head: (ctx) => applySeo(ctx.matches, ((_c: unknown) => {
    const url = "https://rrlexjuristas.com/reserva-confirmada";
    const title = "Reserva confirmada — RR Lex Juristas";
    const description =
      "Tu consulta jurídica está registrada. Te confirmamos por email los próximos pasos para preparar tu cita con nuestras abogadas.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { name: "robots", content: "noindex" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary" },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  })(ctx)),
});

function BookingConfirmed() {
  const { tk } = useT();

  return (
    <Layout>
      <ConfirmationLayout
        eyebrow={tk("reserva.confirmed.eyebrow", "Cita registrada")}
        title={tk("reserva.confirmed.07da12", "Reserva")}
        titleAccent={tk("reserva.confirmed.8b0d05", "confirmada")}
        body={tk(
          "reserva.confirmed.pending.body",
          "Hemos recibido tu reserva y estamos verificando el pago con la pasarela. Te enviaremos un email de confirmación con la fecha y hora en cuanto se complete.",
        )}
        waMessage={tk("reserva.confirmed.119191", "Hola, acabo de reservar una consulta.")}
        steps={[
          {
            title: tk("reserva.confirmed.step1.title", "Email de confirmación"),
            body: tk(
              "reserva.confirmed.step1.body",
              "Te enviamos la fecha, la hora y la dirección o el enlace de videollamada.",
            ),
          },
          {
            title: tk("reserva.confirmed.step2.title", "Preparamos tu consulta"),
            body: tk(
              "reserva.confirmed.step2.body",
              "Revisamos el motivo que nos has indicado antes de la cita para aprovechar los 45 minutos.",
            ),
          },
          {
            title: tk("reserva.confirmed.step3.title", "Qué traer"),
            body: tk(
              "reserva.confirmed.step3.body",
              "Cualquier documento relacionado con tu caso: contratos, notificaciones o resoluciones.",
            ),
          },
        ]}
      />
    </Layout>
  );
}
